var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-white border-gray-200 border-b relative lg:static lg:overflow-y-visible z-10000"},[_c('div',{staticClass:"max-w-7xl mx-auto py-1 px-4 sm:px-6 lg:px-8"},[_vm._t("navigation",function(){return [_c('DefaultNavigation',[_vm._t("default")],2)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }